import inventoryAdjustmentQueryApi from "../../../api/inventory/inventoryAdjustmentQueryApi";
import {
  InventoryAdjustmentFilter,
  InventoryAdjustmentTableDTO,
} from "../../../types/inventory/adjustment/InventoryAdjustmentTypes";
import { InventoryAdjustmentFormValues } from "../../../types/inventory/adjustment/nventoryAdjustmentFormValues";

const InventoryAdjustmentQueryService = {
  /**
   * 🔎 Obtiene ajustes con filtros + paginación.
   * POST /api/inventory/adjustments/query/filter?page=X&size=Y&sort=campo,asc
   */
  getFiltered: async (
    filter: InventoryAdjustmentFilter,
    page = 0,
    size = 10,
    sort = "createdAt,desc"
  ) => {
    const response = await inventoryAdjustmentQueryApi.addCustom(
      `/filter?page=${page}&size=${size}&sort=${sort}`,
      filter
    );
    return response.data;
  },

  /**
   * 📄 Obtiene un ajuste por ID (vista tabla).
   * GET /api/inventory/adjustments/query/{id}
   */
  getById: async (id: number) => {
    const response = await inventoryAdjustmentQueryApi.fetchCustom(`/${id}`);
    return response.data;
  },

  /**
   * ⏳ Obtiene ajustes pendientes (CREATED).
   * GET /api/inventory/adjustments/query/pending
   */
  getPending: async () => {
    const response = await inventoryAdjustmentQueryApi.fetchCustom("/pending");
    return response.data;
  },

  /**
   * 🔁 Obtiene el formulario para continuar un ajuste pendiente.
   * GET /api/inventory/adjustments/query/{id}/continue
   */
  getPendingForm: async (
    id: number
  ) => {
    const response = await inventoryAdjustmentQueryApi.fetchCustom(
      `/${id}/continue`
    );
    return response.data;
  },

  /**
   * 🔢 Obtiene el contador de ajustes pendientes.
   * GET /api/inventory/adjustments/query/pending/count
   */
  getPendingCount: async () => {
    const response = await inventoryAdjustmentQueryApi.fetchCustom(
      "/pending/count"
    );
    return response.data;
  },
};

export default InventoryAdjustmentQueryService;
